import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ParsedTextBlockComponent } from '../parsed-text-block/parsed-text-block.component';

@Component({
  standalone: true,
  imports: [CommonModule, ParsedTextBlockComponent],
  selector: 'joymo-help',
  templateUrl: './help.component.html',
  host: { class: 'flex flex-column flex-align-start flex-justify-center' },
})
export class HelpComponent {
  @Input() supportEmailLink?: string | null;
  @Input() faqLink?: string | null;
  @Input() isLarge?: boolean;
  @Input() streamHelpText?: string | null;
}
